/* eslint-disable camelcase */
import { useEffect } from 'react';
import { useStore } from 'store';
import { Col, Container, Row, Button, Image, ProgressBar } from 'react-bootstrap';
import _isEmpty from 'lodash/isEmpty';
import bankCardIcon from 'assets/img/bank-card-icon.svg';
// eslint-disable-next-line no-unused-vars
import weddingRing from 'assets/img/wedding-ring.svg';
import { Link } from 'react-router-dom';
// import { useStorage64 } from 'hooks';
import CurrencyFormat from 'components/Helpers/CurrencyFormat';
// import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import regaloIcon from 'assets/img/regaloicon.png';
// eslint-disable-next-line no-unused-vars
import cartaCorazon from 'assets/img/iconWishlist1.svg';
import styles from './styles.module.scss';
import BarMobile from 'pages/Header/Content/components/BarMobile';
import { useWindowSize } from 'hooks';

export default function GiftsReceivedLayout({
  children,
  className = '',
  showAccumulatedAmount = true,
  title = '',
  id,
  agent,
  adminheader = sessionStorage.getItem('admin_header'),
  icono = '0',
  TableHero_icon = regaloIcon
}) {
  // const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const [tableInfo, dispatch] = useStore(
    (state) => state.giftTable.giftTableInfo.data
  );
  //const adminheader = sessionStorage.getItem('admin_header');
  //console.log('HEADERADMIN22',adminheader);
  const [,{isMobile}] = useWindowSize()

  useEffect(() => {
    if (_isEmpty(tableInfo)) {
      dispatch(fetchGiftTableInfo({ id, showLoader: true }));
    }
  }, [tableInfo, id]);

  const MyProgressBar = ({ value, max }) => {
    const progress = (value / max) * 100;

    return (
      <ProgressBar now={progress} label={`${value} de ${max}`} />
    );
  };

  const maxValue = 5000;
  let restan = maxValue - tableInfo?.total_purchases;

  return (
    <>
      <BarMobile pageName='Mis regalos recibidos' marginBottom='26px'/>
      <Container className={`mb-5 mt-2 pb-3 ${className}`}>
        <div className={styles['icon-and-title-container']}>
          {icono === '1' && <>
            <div xs={6} className={styles.icon}>
              <img src={TableHero_icon} alt="" />
            </div>
            <div xs={6} className={styles.text}>
              <h1>{title}</h1>
            </div>
          </>}
        </div>
            <hr width="95%" />
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <h2 className={`${!isMobile && 'font-weight-bold'} my-md-4 my-2 ${isMobile ? 'h5' :  'h4'} h-md-2`}>{tableInfo?.name}</h2>
          </Col>
        </Row>

        {showAccumulatedAmount && (
          <>
            <Row className=" mb-2 mt-3 mt-md-3">
              <Col className="text-left">
                <h4 className={`font-weight-bold ${isMobile ? 'h6' :  'h4'} h-md-2`}>
                  Total acumulado {' '}
                </h4>
              </Col>
              <Col  className=" text-right my-md-0">
                <h2 className={`font-weight-bold ${isMobile ? 'h6' :  'h5'} h-md-2`}>
                  <CurrencyFormat
                    className="d-inline"
                    price={tableInfo?.total_purchases}
                  />
                </h2>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs={12} className="text-center">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="w-100">
                    <MyProgressBar value={tableInfo?.total_purchases} max={maxValue} />
                  </div>
                  <i className="fa fa-gift fa-2x ml-2 text-danger" />
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs={12} className="text-center my-4">
                {
                  restan > 0
                    ? <p>¡Te faltan <CurrencyFormat className="d-inline" price={restan} /> para desbloquear tu regalo</p>
                    : <p>Desbloqueaste tu regalo</p>
                }
              </Col>
            </Row>
            {
              tableInfo?.wallet ? 
              <Row className="justify-content-center">
                <Col xs={12} className="text-center my-4">
                  <Link className="link-button" to={agent ? `/my-wallet?agent_staff=${agent}&admin=${adminheader}` : `/my-wallet?admin=${adminheader}`}>
                      <Button>
                        <Image
                          className="mr-3 mb-1"
                          src={bankCardIcon}
                          alt="Bank card icon"
                        />
                        Ver monedero SEARS
                      </Button>
                    </Link>
                </Col>
              </Row> 
              : null
            }
            
          </>
        )}
        <>{children}</>
      </Container>
    </>

  );
}
